// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuAdminCreate{
    max-width: 374px;
    max-height: 500px;
}

.SideMenuAdminCreate_header {
    padding: 20px 20px 0 20px;
    border-bottom: 1px solid #E5E5E5;
}

.SideMenuAdminCreate_header h3 {
    margin: 0 0 15px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.SideMenuAdminCreate_form {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.SideMenuAdminCreate_button {
    padding: 10px;
    border: none;
    border-radius: 4px;
    background: #4CAF50;
    color: white;
    cursor: pointer;
    font-size: 16px;
}

.SideMenuAdminCreate_success {
    color: #4CAF50;
    text-align: center;
}

.SideMenuAdminCreate_message {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 10px 20px;
    border-radius: 4px;
    color: white;
    z-index: 1000;
    background-color: #ff4444;
}

.SideMenuAdminCreate_message--error {
    background-color: #4CAF50 !important;
}

.SideMenuAdminCreate_input--error .commonInputText_field {
    color: #ff4444;
    background-color: #fff0f0;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/SideMenuAdminCreate.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ","sourcesContent":[".SideMenuAdminCreate{\n    max-width: 374px;\n    max-height: 500px;\n}\n\n.SideMenuAdminCreate_header {\n    padding: 20px 20px 0 20px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.SideMenuAdminCreate_header h3 {\n    margin: 0 0 15px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.SideMenuAdminCreate_form {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.SideMenuAdminCreate_button {\n    padding: 10px;\n    border: none;\n    border-radius: 4px;\n    background: #4CAF50;\n    color: white;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.SideMenuAdminCreate_success {\n    color: #4CAF50;\n    text-align: center;\n}\n\n.SideMenuAdminCreate_message {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    padding: 10px 20px;\n    border-radius: 4px;\n    color: white;\n    z-index: 1000;\n    background-color: #ff4444;\n}\n\n.SideMenuAdminCreate_message--error {\n    background-color: #4CAF50 !important;\n}\n\n.SideMenuAdminCreate_input--error .commonInputText_field {\n    color: #ff4444;\n    background-color: #fff0f0;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
